export const environment = {
  version: require('../../package.json').version,
  production: false,
  staging: true,
  development: false,
  apiUrl: 'https://apiadmintest2.copernicuspay.cloud/api/v1',
  serverStellar: 'https://horizon-testnet.copernicuspay.cloud',
  stellarUser: 'stellar',
  stellarPassword: 'N9Y`!/LM{"f?%"@j',
};